import template from './admin-detail.html';
import controller from './admin-detail.controller';
import './admin-detail.scss';

let adminDetailComponent = {
  bindings: {},
  template,
  controller
};

export default adminDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/admin/admin-detail.component.js